import PropTypes from "prop-types";
import React, {Component} from "react";
import {inject} from "mobx-react"

@inject("taskStore")
export class TryEdit extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    taskStore: PropTypes.shape({ isEditMode: PropTypes.bool, setEditMode: PropTypes.func })
  }

  beEditing = () => {
    this.props.taskStore.setEditMode(true)
  }

  render() {
    const canEdit = true; // TODO
    return (this.props.taskStore.isEditMode || !canEdit)
      ? React.Children.only(this.props.children)
      : <div style={{cursor: 'pointer'}} onClick={this.beEditing}>{this.props.children}</div>

  }
}
